import React, { useEffect, useState } from "react"
import Modal from "react-modal"
import "./index.css"

Modal.setAppElement(
	document.getElementById("root") ?? document.getElementsByTagName("div")[0]
)

interface LoadingProps {
	loading: boolean
}

const Loading: React.FC<LoadingProps> = ({ loading }) => {
	const [modalIsOpen, setModalIsOpen] = useState<boolean>(loading)

	useEffect(() => {
		setModalIsOpen(loading)
	}, [loading])

	return (
		<>
			<Modal isOpen={modalIsOpen} className="loading-div">
				<div className="loader-grid">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</Modal>
		</>
	)
}

export default Loading
